import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChipClock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 13,
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		opacity: .2,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.75 4.5H6V7L8.14 8.27L8.5 7.665L6.75 6.625V4.5ZM6.5 2C5.30653 2 4.16193 2.47411 3.31802 3.31802C2.47411 4.16193 2 5.30653 2 6.5H0.5L2.48 8.515L4.5 6.5H3C3 5.57174 3.36875 4.6815 4.02513 4.02513C4.6815 3.36875 5.57174 3 6.5 3C7.42826 3 8.3185 3.36875 8.97487 4.02513C9.63125 4.6815 10 5.57174 10 6.5C10 7.42826 9.63125 8.3185 8.97487 8.97487C8.3185 9.63125 7.42826 10 6.5 10C5.535 10 4.66 9.605 4.03 8.97L3.32 9.68C3.7358 10.1002 4.23117 10.4334 4.77716 10.66C5.32316 10.8867 5.90884 11.0022 6.5 11C7.69347 11 8.83807 10.5259 9.68198 9.68198C10.5259 8.83807 11 7.69347 11 6.5C11 5.30653 10.5259 4.16193 9.68198 3.31802C8.83807 2.47411 7.69347 2 6.5 2Z",
			fill: "white"
		})
	})
});
export default SvgChipClock;
